import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { useSaveChecklist, useSaveChecklistResponsibleByEmail } from './workflow.hooks'
import { MilestoneChecklistStatus } from '../constants/workflow.constants'
import { Checklist } from '../types/workflow.types'

export const useChecklistResponsible = () => {
  const { t } = useTranslation()
  const { mutateAsync: saveChecklist } = useSaveChecklist()
  const { mutateAsync: setChecklistResponsible } = useSaveChecklistResponsibleByEmail()

  const setResponsible = async (objectId: number, milestoneId: number, email: string, checklist?: Checklist) => {
    let checklistId = checklist?.id

    try {
      if (!checklistId) {
        const newChecklist = await saveChecklist({
          objectId: objectId,
          status: MilestoneChecklistStatus.New,
          milestoneId: milestoneId,
          checklist: {},
          comment: {},
        })
        checklistId = newChecklist.id
      }

      await setChecklistResponsible({
        checklistId,
        responsibleEmail: email,
      })

      toast.success(t('workspace.setResponsibleSuccess'))
    } catch {
      toast.error(t('workspace.setResponsibleError'))
    }
  }

  return { setResponsible }
}
